import React from 'react';
import './header.style'
import { Header } from './header'

export default () => { return <Header />; };